import {useCallback, useState} from 'react';
import {shallowEqual, useSelector, useStore} from 'react-redux';
import {AdditionalLinks as AdditionalLinksEditor} from '~/CreateFabricInvitation/routes/EventDetails/components/AdditionalLinks/AdditionalLinks';
import {selectEventLinks, updateEventLinks} from '~/common/event/eventAttributes/reducer';
import type {EventLink} from '~/common/event/types';
import {AddButtonWithTitle} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/AddButtonWithTitle/AddButtonWithTitle';
import {FakeInput} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/FakeInput/FakeInput';

export const AdditionalLinks = () => {
  const store = useStore();
  const [isEditing, setIsEditing] = useState(false);
  const links: EventLink[] = useSelector(selectEventLinks, shallowEqual);

  const onRemoveLink = useCallback(
    (index: number) => {
      const updatedLinks = [...links];
      updatedLinks.splice(index, 1);
      store.dispatch(updateEventLinks(updatedLinks));
    },
    [links, store]
  );

  const openEditor = () => setIsEditing(true);
  const closeEditor = () => setIsEditing(false);

  return (
    <>
      {links.length > 0 ? (
        links.map((link, index) => (
          <FakeInput
            // biome-ignore lint/suspicious/noArrayIndexKey: no better unique key available
            key={index}
            title={`Link ${index + 1}`}
            value={link.display_name || link.url}
            onClick={openEditor}
            onRemove={() => onRemoveLink(index)}
            dataQaId={`event-link-${index}`}
          />
        ))
      ) : (
        <AddButtonWithTitle label="Links" onClick={openEditor} dataQaId="add-additional-links" />
      )}
      <AdditionalLinksEditor
        overlayOpen={isEditing}
        onCloseOverlay={closeEditor}
        renderOverlayOnly
      />
    </>
  );
};
